import React from 'react';
import { Wrench } from 'lucide-react';
import { Button } from './ui/button';

const Hero = ({ onGetStarted }) => {
  return (
    <div className="relative bg-gradient-to-b from-gray-50 to-white py-20 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center justify-center w-24 h-24 mb-6 rounded-full bg-blue-50">
          <Wrench className="w-12 h-12 text-blue-600" />
        </div>
        
        <h1 className="text-5xl font-bold text-gray-900 mb-4">
          Mobile Phone Repair
        </h1>
        
        <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed">
          We're here to help. Our certified technicians provide professional repairs at your doorstep — 
          using genuine parts designed for quality, safety, and performance.
        </p>
        
        <Button 
          onClick={onGetStarted}
          size="lg" 
          className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg transition-all duration-200"
        >
          Get Started
        </Button>
      </div>
    </div>
  );
};

export default Hero;